import { Root } from '@radix-ui/react-toast';
import { PropsWithChildren } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

import { toastVariants } from './Toast.cva';
import { ToastProps } from './Toast.types';

export function Toast({ className, variant, ...props }: PropsWithChildren<PropsWithClassName<ToastProps>>) {
  return <Root className={cn(toastVariants({ variant }), className)} {...props} />;
}
